import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-image":"url('media/illustrations/progress-hd.png')"}
}
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "mb-12"
}, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Logo",
    src: "media/logos/Pryal.png",
    class: "h-100px"
  })
], -1)
const _hoisted_4 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_5 = { class: "text-center mb-10" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h1", { class: "text-dark mb-3" }, " Entrar no Painel Administrador ", -1)
const _hoisted_7 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" É novo? ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Criar uma conta ")
const _hoisted_10 = { class: "fv-row mb-10" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Email", -1)
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "fv-row mb-10" }
const _hoisted_15 = { class: "d-flex flex-stack mb-2" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Senha", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Esqueceu a senha? ")
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Entrar ", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Aguarde... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Form, {
          class: "form w-100",
          id: "kt_login_signin_form",
          onSubmit: _ctx.onSubmitLogin,
          "validation-schema": _ctx.login
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_router_link, {
                  to: "/sign-up",
                  class: "link-primary fw-bolder"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "text",
                name: "login",
                autocomplete: "off"
              }),
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode(_component_ErrorMessage, { name: "email" })
                ])
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_router_link, {
                  to: "/password-reset",
                  class: "link-primary fs-6 fw-bolder"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "password",
                name: "senha",
                autocomplete: "off"
              }),
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_ErrorMessage, { name: "password" })
                ])
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("button", _hoisted_21, [
                _hoisted_22,
                _hoisted_23
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ]))
}